export interface PersonalDataAccessModel {
  id: string;
  accessDate: string;
  userRole: UserRole;
  userName: string;
  userIp: string;
  action: Action;
  url: string;
  description: string;
}

export interface StudentFullName {
  id: string;
  firstName: string;
  lastName: string;
}

export interface PersonalDataChanges {
  id: string;
  changeDate: string;
  userLogin: string;
  userName: string;
  userIp: string;
  origin: Origin;
  action: DataChangeAction;
  identifierType: string;
  identifierValue: string;
  firstName: string;
  lastName: string;
  changesRange: FieldChange[];
}

export interface UserPersonalDataChanges {
  id: string;
  changeDate: string;
  userLogin: string;
  userName: string;
  userIp: string;
  origin: OriginRole;
  action: UserPersonalDataChangeAction;
  firstName: string;
  lastName: string;
  changesRange: FieldChange[];
}

export interface FieldChange {
  fieldName: FieldName;
  oldValue: string | null;
  newValue: string | null;
}

export enum DataChangeAction {
  CREATE_CHILD = 'create_child',
  UPDATE_CHILD = 'update_child',
  REMOVE_CHILD = 'remove_child',
  UDPATE_CHILD_PERMANENT_ADDRESS = 'update_child_permanent_address',
  UPDATE_CHILD_RESIDENTIAL_ADDRESS = 'update_child_residential_address',
  REGISTER_CHILD_GUARDIAN = 'register_child_guardian',
  REMOVE_CHILD_GUARDIAN = 'remove_child_guardian',
  UPDATE_CHILD_GUARDIAN = 'update_child_guardian',
  CREATE_STUDENT = 'create_student',
  UPDATE_STUDENT = 'update_student',
  REMOVE_STUDENT = 'remove_student',
}

export enum UserPersonalDataChangeAction {
  CREATE_OFFICIAL = 'create_official',
  UPDATE_OFFICIAL = 'update_official',
  REMOVE_OFFICIAL = 'remove_official',
  CREATE_APPLICANT = 'create_applicant',
  UPDATE_APPLICANT = 'update_applicant',
  REMOVE_APPLICANT = 'remove_applicant',
}

export enum UserRole {
  ROLE_ADMIN = 'role_admin',
  ROLE_USER = 'role_user',
}

export enum Action {
  PRINTOUT = 'printout',
  OBLIGATION_REPORT_CHILDREN_LIST = 'obligation_report_children_list',
  CATCHMENT_ASSIGNMENT_CHILDREN_LIST = 'catchment_assignment_children_list',
  CATCHMENT_ASSIGNMENT_CHILDREN_LIST_ALERT = 'catchment_assignment_children_list_alert',
  STUDENT_REGISTER_FETCH = 'student_register_fetch',
  TEMPLATE_CHILD_REGISTER_GENERATE = 'template_child_register_generate',
  OTHER_COMMUNE_STUDENT_LIST = 'other_commune_student_list',
}

export enum Origin {
  CHILD_REGISTER = 'ked',
  STUDENTS = 'ku',
}

export enum OriginRole {
  OFFICIAL = 'official',
  APPLICANT = 'applicant',
  ALL = '',
}

export enum FieldName {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  SECOND_NAME = 'second_name',
  IDENTIFIER_TYPE = 'identifier_type',
  IDENTIFIER_VALUE = 'identifier_value',
  COUNTRY = 'country',
  CITY_NAME = 'city_name',
  STREET_NAME = 'street_name',
  BUILDING_NUMBER = 'building_number',
  APARTMENT_NUMBER = 'apartment_number',
  POSTAL_CODE = 'postal_code',
  COMMUNE_NAME = 'commune_name',
  SEX = 'sex',
  BIRTH_DATE = 'birth_date',
  BIRTH_PLACE = 'birth_place',
}

export interface UserPersonalDataChangeFiltersModel {
  dateFrom?: string;
  dateTo?: string;
  origin?: OriginRole;
  userLogin?: string;
  nameAndLastName?: string;
}

export interface DataChangeFiltersModel {
  dateFrom?: string;
  dateTo?: string;
  identifierValue?: string;
  origin?: Origin;
  userLogin?: string;
  nameAndLastName?: string;
}

export interface BrowserPrinterListActionHandlers {
  details: (id: string) => void;
}
